export const ASSESSMENT_SUMMARY_REQUEST = "ASSESSMENT_SUMMARY_REQUEST";
export const ASSESSMENT_SUMMARY_RECEIVE = "ASSESSMENT_SUMMARY_RECEIVE";
export const ASSESSMENT_SUMMARY_FAILURE = "ASSESSMENT_SUMMARY_FAILURE";
export const RESET_ASSESSMENT_SUMMARY = "RESET_ASSESSMENT_SUMMARY";
